import React from 'react';

/** A labelled cell in a filter grid. */
const Field: React.FC<{ label: string; className?: string; children: React.ReactNode }> = ({
    label, className = '', children,
}) => (
    <label className={`flex flex-col gap-1 ${className}`}>
        <span className="text-xs font-medium text-muted">{label}</span>
        {children}
    </label>
);

export default Field;
